import request from '@/utils/request'
const BASE_URL = '/EnumData'

export default {
    list(data) {
        return request({
            url: BASE_URL + '/List',
            method: 'post',
            data
        })
    },
    info(id) {
        return request({
            url: BASE_URL + '/Info',
            method: 'get',
            params: {
                id
            }
        })
    },
    nameinfo(name) {
        return request({
            url: BASE_URL + '/NameInfo',
            method: 'get',
            params: {
                name
            }
        })
    },
    save(data) {
        return request({
            url: BASE_URL + '/Save',
            method: 'post',
            data
        })
    },
    delete(data) {
        return request({
            url: BASE_URL + '/Delete',
            method: 'post',
            data
        })
    }
}